import { FocusIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
  DialogTrigger,
} from '../../ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { DialogPortal } from '@radix-ui/react-dialog';

export interface ImagePreviewProps {
  imgSrc: string;
  width?: number;
  height?: number;
  previewWidth?: number;
  isPreviewRatioFixed?: boolean;
}

export default function ImagePreview({
  imgSrc,
  width = 100,
  height = 100,
  previewWidth = 700,
  isPreviewRatioFixed = true,
}: ImagePreviewProps) {
  return (
    <Dialog>
      <DialogTrigger className="group relative w-fit overflow-hidden rounded-md md:w-fit">
        <img
          style={{
            width,
            height,
            objectFit: 'cover',
          }}
          width={width}
          height="auto"
          src={imgSrc}
          alt="image thubnail"
        />
        <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 transition-opacity group-hover:opacity-100">
          <FocusIcon color="#fff" />
        </div>
      </DialogTrigger>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent className="w-fit md:w-fit">
          <DialogHeader className="w-fit">
            <DialogTitle>이미지 자세히보기</DialogTitle>
          </DialogHeader>
          <ScrollArea className="max-h-[calc(100vh-200px)] overflow-x-hidden">
            <div className="p-6">
              <img
                className="rounded-md object-cover"
                width={previewWidth}
                height="auto"
                src={imgSrc}
                alt="image preview"
                style={
                  isPreviewRatioFixed
                    ? { aspectRatio: `${width}/${height}` }
                    : { objectFit: 'contain' }
                }
              />
            </div>
          </ScrollArea>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
